/*
 * Advertorial PDP-style buy block.
 * - shows the price of the selected Kaching bar (same idea as the PDP section)
 * - Add to Cart: adds the item and opens the theme cart drawer.
 * Kaching rewrites the /cart/add.js request itself (quantity + selling plan),
 * exactly as on the product page.
 */
(() => {
  if (customElements.get('advertorial-buy')) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const BAR = '.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar';

  async function postJSON(path, body) {
    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Unable to add this product to cart.');
    return data;
  }

  class AdvertorialBuy extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.atc = this.querySelector('[data-advertorial-atc]');
      this.priceEl = this.querySelector('[data-advertorial-price]');
      this.compareEl = this.querySelector('[data-advertorial-compare]');
      this.errorEl = this.querySelector('[data-advertorial-error]');
      if (!this.form || !this.atc) return;

      this.form.addEventListener('submit', (event) => {
        const submitter = event.submitter;
        if (submitter && !submitter.matches('[data-advertorial-atc]')) return;
        event.preventDefault();
        this.addToCart();
      });

      // Kaching renders asynchronously and re-renders on every bar / subscription change.
      const schedule = () => {
        clearTimeout(this.syncTimer);
        this.syncTimer = setTimeout(() => this.syncPrice(), 80);
      };
      this.observer = new MutationObserver(schedule);
      this.observer.observe(this.form, { subtree: true, childList: true, attributes: true, characterData: true });
      this.form.addEventListener('click', schedule);
      this.form.addEventListener('change', schedule);
      schedule();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    selectedBar() {
      return (
        this.querySelector(`${BAR}--selected`) ||
        (this.querySelector(`${BAR} input[type="radio"]:checked`) || {}).closest?.('.kaching-bundles__bar') ||
        null
      );
    }

    syncPrice() {
      const bar = this.selectedBar();
      if (!bar) return;
      const price = bar.querySelector('.kaching-bundles__bar-price');
      const full = bar.querySelector('.kaching-bundles__bar-full-price');
      const priceText = price ? price.textContent.trim() : '';
      const fullText = full ? full.textContent.trim() : '';
      if (priceText && this.priceEl.textContent.trim() !== priceText) this.priceEl.textContent = priceText;
      if (this.compareEl) {
        const showCompare = fullText && fullText !== priceText;
        this.compareEl.hidden = !showCompare;
        if (showCompare && this.compareEl.textContent.trim() !== fullText) this.compareEl.textContent = fullText;
      }
    }

    lineItemFromForm() {
      const data = new FormData(this.form);
      const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 };
      const sellingPlan = data.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      const properties = {};
      data.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });
      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    async addToCart() {
      if (this.atc.disabled) return;
      this.atc.disabled = true;
      this.atc.classList.add('is-loading');
      this.errorEl.hidden = true;

      const drawer = document.querySelector('cart-drawer');
      const sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map((s) => s.id)
        : [];

      try {
        const payload = { items: [this.lineItemFromForm()] };
        if (sectionIds.length) {
          payload.sections = sectionIds;
          payload.sections_url = window.location.pathname;
        }
        const response = await postJSON('cart/add.js', payload);

        if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.atc);
          drawer.renderContents(response); // Dawn/Sense: re-renders and opens the drawer
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (error) {
        this.errorEl.textContent = error.message;
        this.errorEl.hidden = false;
      } finally {
        this.atc.disabled = false;
        this.atc.classList.remove('is-loading');
      }
    }
  }

  customElements.define('advertorial-buy', AdvertorialBuy);
})();